

































































































import { Component, Vue } from 'vue-property-decorator';
import {GeneralService} from '../services/general-service';
import ProgramLevel from '../components/ProgramLevel.vue';
import config from '../services/api-config';
import router from '../router';
import AuthService from '../services/auth-service';
import VueApexCharts from "vue-apexcharts";

@Component({
  components: {
      apexchart: VueApexCharts,
  },
})

export default class ExamResult extends Vue {
    private service = new GeneralService();
    private auth = new AuthService();
    private examData: any = [];
    private examDataParsed: any = [];
    private view = 1;
    private isGrade = false;
    private totalExams: any = [];
    private totalSubjects: any = [];
    private selectedExam = "";
    private selectedSubject = "";
    private isInter = true;
    private isMatric = true;

    private showSubject() {
      this.view = 2;
      this.createSeriesSubject(this.totalSubjects[0]);
    }

    private showExam() {
      this.view = 3;
      this.createSeriesExam(this.totalExams[0]);
    }

    private getGrade(percentage) {
      if (this.isGrade) {
        if (percentage >= 90 )
          return 'A+'
        else if (percentage >= 87)
          return 'A'
        else if (percentage >= 82)
          return 'B+'  
        else if (percentage >= 77)
          return 'B'
        else if (percentage >= 70)
          return 'C+'  
        else if (percentage >= 60)
          return 'C'  
        else if (percentage >= 50)
          return 'D+' 
        else if (percentage >= 40)
          return 'D' 
        else if (percentage >= 33)
          return 'E'
        else if (percentage >= 0)
          return 'F'
        else 
          return 'N/A'
      } else {
        return percentage.toFixed(1) + '%'
      }
    }

    private options: any = {};

    private series: any = [];

    createSeriesSubject(subject: string) {
      this.selectedSubject = subject;
      let dataSubject: any = [];
      
      for (let i = 0; i < this.totalExams.length; i++){
        const elementData = this.examDataParsed[subject].filter(e => e.Title == this.totalExams[i])[0];
        const perc = this.examDataParsed[subject].filter(e => e.Title == this.totalExams[i])[0] ? this.examDataParsed[subject].filter(e => e.Title == this.totalExams[i])[0].Percentage : 0;
        if (elementData)
          dataSubject.push({x: this.totalExams[i], y: perc.toFixed(1), raw: elementData.Obtained_Marks + '/' + elementData.TotalMarks})
      }

      this.series = [{name: subject, data: dataSubject}];
      let subjectData = this.examDataParsed[subject][0];
      let matricPerc = subjectData.ObtainMarkMatric/subjectData.TotalMarksMatric*100;
      let interPerc = subjectData.ObtainMarksInter/subjectData.TotalMarksInter*100;

      if (subjectData.ObtainMarkMatric == 0 || subjectData.TotalMarksMatric == 0)
        matricPerc = 0;
      
      if (subjectData.ObtainMarksInter == 0 || subjectData.TotalMarksInter == 0)
        interPerc = 0;
      
      this.options = {
        chart: {
          type: 'bar',
          width: '70%',
        },

        yaxis: {
          min: 0,
          max: 100,
          tickAmount: 5,
          title: {
            text: 'Percentage %',
          }
        },
        plotOptions: {
          bar: {
            columnWidth: '20px',
          }
        },
        colors: ['#2E2A6F'],
        legend: {
          show: false,
        },
        dataLabels: {
          enabled: false
        },
        annotations: {
          yaxis: [
            this.isMatric && {
              y: matricPerc,
              borderColor: '#EEE394',
              strokeDashArray: 0,
              label: {
                borderColor: '#EEE394',
                textAnchor: 'start',
                position: 'left',
                style: {
                  color: '#2E2A6F',
                  background: '#EEE394'
                },
                text: 'Matric Marks ' + matricPerc.toFixed(2) + ' %'
              }
            },
            this.isInter && {
              y: interPerc,
              strokeDashArray: 0,
              borderColor: '#A8D5F6',
              label: {
                borderColor: '#A8D5F6',
                style: {
                  color: '#2E2A6F',
                  background: '#A8D5F6'
                },
                text: 'Part 1 Marks ' + interPerc.toFixed(2) + ' %' 
              }
            }
          ]
        }
      }
    }

    createSeriesExam(exam: string) {
      this.selectedExam = exam;
      let dataSubject: any = [];
      let dataInter: any = [];
      let dataMatric: any = [];
      
      for (let i = 0; i < this.totalSubjects.length; i++){
        const elementData = this.examDataParsed[this.totalSubjects[i]].filter(e => e.Title == exam)[0];
        const perc = this.examData.filter(e => e.Title == exam && e.Subject == this.totalSubjects[i])[0] ? this.examData.filter(e => e.Subject == this.totalSubjects[i] && e.Title == exam)[0].Percentage : 0;
        const percMatric = elementData ? (elementData.ObtainMarkMatric/elementData.TotalMarksMatric*100).toFixed(1) : 0;
        const percInter = elementData ? (elementData.ObtainMarksInter/elementData.TotalMarksInter*100).toFixed(1) : 0;
        
        if (elementData){
          dataSubject.push({x: this.totalSubjects[i], y: perc.toFixed(1), raw: elementData.Obtained_Marks + '/' + elementData.TotalMarks});
          dataMatric.push({x: this.totalSubjects[i], y: percMatric});
          dataInter.push({x: this.totalSubjects[i], y: percInter});
        }
      }

      this.series = [{name: exam, data: dataSubject}, {name: 'Matric', data: dataMatric}, {name: 'Part 1', data: dataInter}];

      this.options = {
        chart: {
          type: 'bar',
          width: '70%',
        },

        yaxis: {
          min: 0,
          max: 100,
          tickAmount: 5,
          title: {
            text: 'Percentage %',
          }
        },
        plotOptions: {
          bar: {
            columnWidth: '20px',
          }
        },
        dataLabels: {
          enabled: false
        },
        legend: {
          show: true,
          showForSingleSeries: true,
          customLegendItems: ['Test', 'Matric', 'Part 1'],
          markers: {
            fillColors: ['#2E2A6F', '#EEE394', '#A8D5F6']
          }
        },
        colors: ['#2E2A6F', '#EEE394', '#A8D5F6'],
        annotations: {
          yaxis: []
        }
      }
    }
    

    mounted (){
        let username = this.auth.session.userName.split('@')[0];
        this.service.getExamEx(username).then(result => {
          this.examData = result.data.Data;
          this.examDataParsed = this.examData.reduce((acc, curr) => {
            if (acc[curr.Subject]){
              acc[curr.Subject].push(curr)
            } else {
              acc[curr.Subject] = [];
              acc[curr.Subject].push(curr);
            }

            return acc;
          }, {});

          this.totalExams = this.examData.reduce((acc, curr) => {
            if (acc.includes(curr.Title))
              return acc
            else {
              acc.push(curr.Title);
              return acc;
            }
          }, [])

          this.totalSubjects = this.examData.reduce((acc, curr) => {
            if (acc.includes(curr.Subject))
              return acc
            else {
              acc.push(curr.Subject);
              return acc;
            }
          }, []);

          this.isInter = this.examData.filter(e => e.TotalMarksInter !== 0).length !== 0;
          this.isMatric = this.examData.filter(e => e.TotalMarksMatric !== 0).length !== 0;
        });
    }
}
